import React from "react";
import clsx from "clsx";

import { IconHamburger } from "../../../../assets";

export default class MobileNavToggleButton extends React.PureComponent {
	render() {
		const { searchIsActive, toggleMobileNav } = this.props;
		const hiddenClassMod = searchIsActive && "--hidden";

		return (
			<div
				role={"button"}
				tabIndex={"0"}
				onClick={toggleMobileNav}
				className={clsx("Navigation__mobile-toggle-button", hiddenClassMod)}
			>
				<IconHamburger className={"navigation-mobile-hamburger"} />
			</div>
		);
	}
}
